import React from 'react';
import {connect} from 'react-redux';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {Link} from 'react-router-dom';
import {Container, Header, Loader, Icon, Segment, Button, Form} from 'semantic-ui-react';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {ContentDispatch} from 'framework';
import SubApplicationCopy from './subApplicationCopy';
import ApiActions from 'go/actions/api';
import _ from 'lodash';
import {API_ORGS_LIST_GET_BY_ID_SUCCESS} from 'common/types';
import {SUBAPPLICATION_TYPE_MAP} from 'go/components/subApplication/constants';
import REST from 'go/requests/rest';
import {getTimestampNowISO} from 'common/utils';
import PermissionsUtility from 'go/security/permissionsUtility';
import {Toggle} from 'componentLibrary';
import {isSubAOR, isUserSelfSarSm} from 'go/security/permissions';
import {ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {START_SUBAPP_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';

export class SubApplicationInitializeComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitOnBehalf: undefined,
      selOrganizationName: undefined,
      entityId: _.get(
        this.props,
        'match.params.fundingOpportunityId',
        _.get(this.props, 'match.params.categoryId')
      ),
      entityType: this.props.match.params.fundingOpportunityId ? 'fo' : 'pc',
      ehpEntityId: null,
      grantCategory: '',
      organizations: [],
      applicationEntityId: null,
      ehpPayload: [],
      copySubapplication: false,
      radioCopy: '',
      foData: null,
    };
  }

  createEhpEntity = async () => {
    this.createApplicationEntity().then((subApp) => {
      const {applyToOrgId, applyForOrgId} = this.props;
      const initialEhpPayload = {
        entityType: 'ehpQuestionnaire',
        categoryId: this.props.match.params.categoryId,
        subOrganizationId: applyForOrgId,
        organizationId: applyToOrgId,
        status: 'pendingSubmission',
        statusTimestamp: getTimestampNowISO(),
        applicationEntityId: this.state.applicationEntityId,
      };

      REST.dynamicData
        .createApplicationEntity(this.props.jwt, initialEhpPayload)
        .then((response) => response.json())
        .then((resJson) => {
          if (resJson) {
            this.setState((prevState) => ({
              ...prevState,
              ehpEntityId: resJson.entityId,
              ehpPayload: initialEhpPayload,
            }));
            this.setState(
              (prevState) => ({
                ...prevState,
                ehpPayload: {
                  ...this.state.ehpPayload,
                  entityId: resJson.entityId,
                  versionId: resJson.versionId,
                },
              }),
              () => {
                this.updateSubApplicationWithEHPId(subApp);
              }
            );
          }
        })
        .catch((error) => {
          console.error('error');
        });
    });
  };

  updateSubApplicationWithEHPId = async (subApp) => {
    subApp.payload.ehpEntityId = {
      entityId: _.get(this.state, 'ehpPayload.entityId'),
    };
    REST.dynamicData
      .updateEntity(this.state.jwt, subApp)
      .then((response) => response.json())
      .then((resJson) => {
        if (resJson) {
          this.props.history.push('/subApplication/' + resJson.entityId);
        }
      });
  };

  createApplicationEntity = async () => {
    const {
      applyToOrgId,
      applyForOrgId,
      applicationTitle,
      documentControlNumber,
      applicationType,
    } = this.props;

    const contextType = this.state.entityType;

    let {auth} = this.props;
    let currentDate = getTimestampNowISO();
    let orgForInfo = {};
    let subOrgName = null;
    let orgName = null;
    await this.props
      .organizations(_.uniq([applyForOrgId, applyToOrgId]), this.props.jwt)
      .then((res) => {
        if (res.type === API_ORGS_LIST_GET_BY_ID_SUCCESS) {
          const orgForData = _.chain(res)
            .get('payload', {})
            .find((o) => o.organizationId == applyForOrgId)
            .value();
          _.set(orgForInfo, 'mailingState', _.get(orgForData, 'mailingAddress.state'));
          _.set(orgForInfo, 'physicalState', _.get(orgForData, 'physicalAddress.state'));
          subOrgName = _.get(orgForData, 'displayName');

          const orgToData = _.chain(res)
            .get('payload', {})
            .find((o) => o.organizationId == applyToOrgId)
            .value();
          orgName = _.get(orgToData, 'displayName');
        }
      });
    let payloadToSend = {
      entityType: 'subApplication',
      subOrganizationId: applyForOrgId,
      organizationId: applyToOrgId,
      status: 'pendingSubmission',
      statusDate: currentDate,
      statusTimestamp: currentDate,
      payload: {
        initiatorLoginName: auth.loginName,
        initiatedTimestamp: currentDate,
        submitterLoginName: 'inProgress',
        submittedTimestamp: 'inProgress',
        applicationTitle: applicationTitle,
        applicationSubmittedFor: this.state.submitOnBehalf,
        documentControlNumber: documentControlNumber,
        activities: [],
        applicationType: applicationType,
        applicationTypeDescription: this.getAppDescription(applicationType),
        submissionType: 'Application',
        subOrgName: subOrgName,
        orgName: orgName,
      },
      organizationInfo: orgForInfo,
    };

    let additionalPayloadConfig = _.get(this.props, 'config.payload.additionalPayload');
    let additionalPayload = {};
    _.each(additionalPayloadConfig, (value, key) => {
      additionalPayload[key] = _.get(
        {props: this.props, entity: payloadToSend},
        value,
        value
      );
    });
    payloadToSend.payload = {
      ...payloadToSend.payload,
      ...additionalPayload,
    };

    if (contextType == 'pc') {
      payloadToSend.categoryId = this.props.match.params.categoryId;
    } else {
      payloadToSend.fundingOpportunityId = +this.props.match.params.fundingOpportunityId;
      payloadToSend.programId = +_.get(this.state, 'foData.programId');
    }

    if (
      _.includes(
        this.props.toggles,
        `programCategory-${this.props.match.params.categoryId}-costShareV2`
      )
    )
      _.set(payloadToSend, 'payload.subAppV2', true);

    // Default setting for 'Advance Assistance' and 'Management Cost' sub-application
    if (
      [
        SUBAPPLICATION_TYPE_MAP.MANAGEMENT_COST.code,
        SUBAPPLICATION_TYPE_MAP.ADVANCED_ASSISTANCE.code,
      ].indexOf(applicationType) !== -1
    ) {
      _.set(payloadToSend, 'payload.scopeOfWork.constructionOnProject', 'false');
    }

    // Set the default Activity Title in the Scope of Work section.
    let activityTitle = 'Unknown';
    if (applicationTitle) {
      activityTitle = applicationTitle;
    }
    _.set(payloadToSend, 'payload.scopeOfWork.proposedActivityTitle', activityTitle);

    let jwt_token = this.props.jwt;

    return REST.dynamicData
      .createApplicationEntity(jwt_token, payloadToSend)
      .then((response) => response.json())
      .then((resJson) => {
        if (resJson) {
          this.setState((prevState) => ({
            ...prevState,
            ehpPayload: {
              ...this.state.ehpPayload,
              applicationEntityId: resJson.entityId,
            },
          }));

          this.setState((prevState) => ({
            ...prevState,
            applicationEntityId: resJson.entityId,
          }));
          return resJson;
        }
      })
      .catch((error) => {
        console.error('error');
      });
  };

  handleSubmit = () => {
    let {entityType} = this.state;
    let value = _.filter(this.props.filterAppTypes, (item) => {
      return Number(item.id) === Number(this.props.applicationType);
    });

    if (
      value !== undefined &&
      value[0] !== undefined &&
      (value[0].id === parseInt(SUBAPPLICATION_TYPE_MAP.PROJECT.code) ||
        value[0].id === parseInt(SUBAPPLICATION_TYPE_MAP.MANAGEMENT_COST.code)) &&
      entityType == 'pc'
    ) {
      this.createEhpEntity();
    } else {
      this.createApplicationEntity().then((resJson) =>
        this.props.history.push('/subApplication/' + resJson.entityId)
      );
    }
  };

  handleChange = (event, {value}) => {
    this.setState({radioCopy: value});
  };

  componentDidMount() {
    const {entityType, entityId} = this.state;
    let configType = 'entityEdit';
    let configId = 'subApplicationInitiation';
    let {getConfig} = this.props;
    const {postDynamicData, saveEntitySessionData} = this.props;

    getConfig(this.props.jwt, entityType, entityId, configType, configId)
      .then(async (res) => {
        this.setState({config: res.payload});
        if (res) {
          let data = {};
          let config = res.payload;
          this.props.init(config, data, {
            apiCall: postDynamicData,
          });

          let foId = null,
            programId = null,
            foRestricted = null;

          if (entityType === 'fo') {
            const foData = await REST.fundingOpportunity
              .getFundingOpportunity(this.props.jwt, entityId)
              .then((res) => res.json())
              .catch((e) => console.error(e));

            if (foData) {
              (foId = foData.fundingOpportunityId),
                (programId = foData.programId),
                (foRestricted = foData.restrictedFundingOpportunityFlag);

              this.setState({
                foData,
                loading: false,
              });
              saveEntitySessionData('fundingOpportunityData', foData);
            }
          }

          // getMySubOrganizations takes jwt token, so no need to iterate over all orgs
          return new Promise((resolve, reject) => {
            REST.organization
              .getMySubOrganizations(this.props.jwt, foId, programId, foRestricted)
              .then(REST.handler.handleResponse)
              .then((res) => {
                if (res) {
                  const subOrgs = res.map((item) => {
                    let parentOrgs = item.parentOrganizations;
                    item = item.organization;
                    const eft = !_.isEmpty(_.trim(item.eft))
                      ? _.trim(item.eft)
                      : _.trim(item.dunsPlus4);
                    const ueiPlusEft = item.uei + (!_.isEmpty(eft) ? '-' + eft : '');
                    const uei = item.uei ? ` | UEI-EFT: ${ueiPlusEft}` : '';
                    const getName = item.displayName + uei;
                    let canHaveSuborgAndSelfSarSM = undefined;
                    if (_.get(this.props, 'userEntities') !== undefined) {
                      canHaveSuborgAndSelfSarSM = _.get(this.props, 'userEntities', [])
                        .filter((y) => {
                          return y.entityId === item.entityId;
                        })
                        .map((x) => {
                          return x.canHaveSuborganizations;
                        })[0];
                      if (canHaveSuborgAndSelfSarSM) {
                        canHaveSuborgAndSelfSarSM =
                          isUserSelfSarSm(
                            this.props.auth.permissions,
                            item.entityId,
                            ROLE_MAP.SUBMEMBER.code
                          ) ||
                          isUserSelfSarSm(
                            this.props.auth.permissions,
                            item.entityId,
                            ROLE_MAP.SUBAUTHREP.code
                          );
                      }
                    }
                    return {
                      legalName: getName,
                      displayName: getName,
                      organizationName: item.entityId,
                      entityId: item.entityId,
                      isOrg: false,
                      orgDisplayName: item.displayName,
                      orgEntityId: item.entityId,
                      parentOrgs: parentOrgs,
                      canHaveSuborgAndSelfSarSM: canHaveSuborgAndSelfSarSM,
                    };
                  });
                  resolve(subOrgs);
                }
                resolve([]);
              })
              .catch((error) => {
                console.error('error');
                resolve([]);
              });
          }).then((subOrgs) => {
            this.setState({orgs: subOrgs});
            this.props.saveEntitySessionData('context.orgs', subOrgs);
            this.props.saveEntitySessionData('context.toggles', this.props.toggles);
          });
        }
      })
      .catch((error) => {
        console.error('Error in getConfig');
      });
  }

  componentDidUpdate(prevProps, prevState) {
    document.title = START_SUBAPP_PAGE;
    const {applyForOrgId, applyToOrgId} = this.props;
    if (applyForOrgId !== undefined && applyToOrgId !== undefined) {
      let submitOnBehalf = undefined;
      if (applyForOrgId === applyToOrgId) {
        submitOnBehalf = 'self';
      } else {
        submitOnBehalf = 'applicant';
      }
      if (
        submitOnBehalf &&
        (prevState.submitOnBehalf === undefined ||
          submitOnBehalf !== prevState.submitOnBehalf)
      ) {
        this.setState({submitOnBehalf: submitOnBehalf});
      }
    }
  }

  grantCategory = (categoryId) => {
    if (this.props.context.loadProgramCategories != undefined) {
      let programCategory = this.props.context.loadProgramCategories.PROGRAM_CATEGORY;
      let grantCategory = _.filter(programCategory, (pg) => {
        return String(pg.id) == String(categoryId);
      });
      if (
        grantCategory[0] !== undefined &&
        (this.state.grantCategory === '' || this.state.grantCategory === undefined)
      ) {
        this.setState({grantCategory: grantCategory[0].displayText});
      }
    }
  };

  getAppDescription = (appId) => {
    if (this.props.context.loadRefApplicantType != undefined) {
      let appTypes = this.props.context.loadRefApplicantType.APPLICATION_TYPE;
      let app = _.filter(appTypes, (app) => {
        return String(app.id) == String(appId);
      });
      if (
        app[0] !== undefined &&
        (this.state.app === '' || this.state.app === undefined)
      ) {
        this.setState({app: app[0].displayText});
      }
      return app[0].displayText;
    }
  };

  setAutoStartNewApplication = (value) => {
    if (this.state.radioCopy === value) return;
    else this.setState({radioCopy: value});
  };

  render() {
    const {config, context, data, dynamicComponent} = this.props;
    const {foData, entityType} = this.state;
    this.grantCategory(this.props.match.params.categoryId);
    return !_.isEmpty(this.props.context.orgs) ? (
      <Main>
        <Container id="subAppInit">
          {entityType === 'pc' ? (
            <Header as="h1">Start a subapplication - {this.state.grantCategory}</Header>
          ) : (
            <Header as="h1">Start a subapplication</Header>
          )}
          <Segment>
            {entityType === 'fo' && foData && (
              <Header as="h2">{foData.fundingOpportunityName} subapplication</Header>
            )}
            {entityType === 'pc' ? (
              <React.Fragment>
                <Toggle toggle="copySubApplication">
                  <Form>
                    <h5>
                      Would you like to start a new subapplication or copy from an
                      existing one?
                    </h5>
                    <Form.Group id="subapplication-newOrCopy">
                      <Form.Radio
                        className="radio-checkbox"
                        label="Start new subapplication"
                        title="Start new subapplication"
                        name="newOrCopy"
                        value="new"
                        checked={this.state.radioCopy === 'new'}
                        onChange={this.handleChange}
                      />
                      <Form.Radio
                        className="radio-checkbox"
                        label="Copy from an existing one"
                        title="Start new subapplication"
                        name="newOrCopy"
                        value="copy"
                        checked={this.state.radioCopy === 'copy'}
                        onChange={this.handleChange}
                      />
                    </Form.Group>
                  </Form>
                  <hr />
                </Toggle>
                <Toggle toggle="!copySubApplication">
                  {this.setAutoStartNewApplication('new')}
                </Toggle>
              </React.Fragment>
            ) : (
              <React.Fragment>{this.setAutoStartNewApplication('new')}</React.Fragment>
            )}
            {this.state.radioCopy === 'new' && (
              <React.Fragment>
                <div ref={this.handleContextRef}>
                  {_.get(config, 'payload') ? (
                    <ContentDispatch
                      className="contentDispatch"
                      config={config.payload}
                      data={data}
                      context={context}
                      dynamicComponent={dynamicComponent}
                      handleSubmit={this.handleSubmit}
                    />
                  ) : (
                    <Loader active inline="centered" />
                  )}
                </div>
                <br />
                <Button
                  color={'blue'}
                  id={'id'}
                  className={false ? 'errorFieldBorder' : ''}
                  value={'value'}
                  type={'type'}
                  onClick={this.handleSubmit}
                  disabled={
                    _.get(dynamicComponent, ['validationErrors', 'allValid'], false) ===
                    false
                  }
                  width={'medium'}
                >
                  {'Start your subapplication'}
                </Button>
                <br />
                <br />
                <Link to="/">
                  <Icon name="cancel" />
                  Cancel
                </Link>
                <br />
                <br />
              </React.Fragment>
            )}
            {this.state.radioCopy === 'copy' && (
              <React.Fragment>
                <hr />
                <SubApplicationCopy
                  categoryId={this.props.match.params.categoryId}
                  jwt={this.props.jwt}
                />
              </React.Fragment>
            )}
          </Segment>
          <br />
        </Container>
      </Main>
    ) : (
      <Loader active>Loading...</Loader>
    );
  }
}

export const mapStateToProps = (state) => {
  const {config, data, context, sessionData} = state.dynamicComponent;
  return {
    data,
    config,
    context,
    applyForOrgId: _.get(sessionData, 'applyForOrgId'),
    applyToOrgId: _.get(sessionData, 'applyToOrgId'),
    applicationTitle: _.get(sessionData, 'applicationTitle'),
    documentControlNumber: _.get(sessionData, 'documentControlNumber'),
    applicationType: _.get(sessionData, 'applicationType'),
    filterAppTypes: _.get(sessionData, 'filterAppTypes'),
    suborgs: _.get(sessionData, 'suborgs'),
    orgs: context.orgs,
    dynamicComponent: state.dynamicComponent,
    jwt: state.auth.token,
    auth: state.auth,
    userEntities: _.get(state, 'userEntities.entitiesData'),
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  init: (config, data, serviceCall) =>
    dispatch(DynamicComponentActions.init(config, data, serviceCall)),

  getConfig: (jwt, entityType, entityId, configType, configId) => {
    let action = ApiActions.config.getConfig(
      jwt,
      entityType,
      entityId,
      configType,
      configId
    );
    const res = dispatch(action);
    return res;
  },
  postDynamicData: (payload, token) => {
    const data = payload.data ? payload.data : payload;
    const dataPayload = JSON.stringify(_.omit(data, ['version']));
    let action = ApiActions.dynamicData.postData(token, dataPayload);
    const res = dispatch(action);
    return res;
  },
  organizations: (orgIds, token) => {
    const action = ApiActions.organization.getOrganizationsListById(token, orgIds);
    return dispatch(action);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(SubApplicationInitializeComponent));
